export default {"src":"/_next/static/media/parking-icon-selected.b3c7e176.svg","height":57,"width":101,"blurWidth":0,"blurHeight":0};